import { IAuftragHinweisResponse } from "../../types/Types";
import { formatToEuroDateTime } from "../../util/DateUtils";

type ThisProps = {
  hinweise: IAuftragHinweisResponse[];
}

/**
 * @author noone
 */
const AuftragHinweiseComponent: React.FC<ThisProps> = (props) => {

  return (
    <>
      {props.hinweise?.map((e, index) => <>
        <div key={'hinweis_' + index + '_' + e.uid} className="card" style={{ marginBottom: '10px' }}>
          <div className="card-body" style={{padding: '10px'}}>
            <p className="card-text">{e.text}</p>
          </div>
          <div className="card-footer text-muted" style={{ fontSize: '0.8em' }}>
            {formatToEuroDateTime(e.erstelltAm)} {e.erstelltVon} {e.typ}
          </div>
        </div>
      </>)}
    </>
  );
}

export default AuftragHinweiseComponent;